import React from 'react';

import { Button, TemplateLibrary } from 'components';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';

import routes from 'lane-shared/config/routes';
import { LANE_TEMPLATE_LIBRARY } from 'lane-shared/helpers/constants/library';

import styles from '../../admin/channel/templates/ChannelTemplateLibrary.scss';

export default function LaneTemplates() {
  const match = useRouteMatch(routes.portalManagementVTSTemplates) as {
    path: string;
  };
  const location = useLocation();

  return (
    <div className={styles.Templates}>
      <TemplateLibrary
        library={LANE_TEMPLATE_LIBRARY}
        TemplateWrapper={({ template, children }: any) => (
          <Link
            to={{
              pathname: `${match.path}/${template._id}/edit`,
              state: { from: location.pathname },
            }}
          >
            {children}
          </Link>
        )}
        additionalMenu={
          <Link
            to={{
              pathname: `${match.path}/new`,
              state: { from: location.pathname },
            }}
          >
            <Button variant="contained">New Template</Button>
          </Link>
        }
      />
    </div>
  );
}
